module.exports = __webpack_public_path__ + "visa.4e629865db94d2917de87129e5ff8ba4.svg";